// extracted by mini-css-extract-plugin
export default {"input":"Y8-z","button":"Z8-z","selected":"_8-z","unavailable":"a9-z","oos":"b9-z","image":"c9-z","paperCutDisabledOverlay":"d9-z"};